module.exports = __webpack_public_path__ + "static/img/showba.0178162.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/showba.jpg
// module id = AYgN
// module chunks = 2